export default __webpack_public_path__ + "static/media/jm.77e67657.svg";